module.exports = __webpack_public_path__ + "static/logo-a76b4a6bb7115138daddb1a8271700b1.jpg";